module.exports = __webpack_public_path__ + "img/趣味训练.81d30de1.png";